import Box from "@mui/material/Box";
import {alpha} from "@mui/material";
import React, {FC} from "react";
import Typography from "@mui/material/Typography";
import {IHomeSteps} from "../../../../store/home/Helper";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material/styles";

interface IProps {
    steps: IHomeSteps[]
}

const VerticalStepper: FC<IProps> = (props) => {
    const {i18n} = useTranslation()
    const theme = useTheme()
    const lineOffset = 12.5

    return (
        <Box mt={4} width="100%">
            <Box sx={{position: 'relative'}}>
                {props.steps.length > 1 && (
                    <Box sx={{
                        position: 'absolute',
                        left: `${lineOffset}px`,
                        top: `${lineOffset}px`,
                        bottom: `${lineOffset}px`,
                        width: "3px",
                        transform: 'translateX(-50%)',
                        background: alpha(theme.palette.primary.main, .7),
                    }}/>
                )}
                <Box sx={{display: 'flex', flexDirection: 'column', rowGap: 3}}>
                    {props.steps.map((s, index) => (
                        <Box key={`${s[`label_${i18n.language}`]}-${index}`}
                             sx={{display: 'flex', alignItems: 'center', columnGap: 2, position: 'relative'}}>
                            <Box sx={{
                                height: '25px',
                                width: '25px',
                                borderRadius: '50%',
                                bgcolor: theme.palette.primary.main,
                                zIndex: 1,
                                flexShrink: 0
                            }}/>
                            <Typography color="primary" variant='h6'>
                                {s[`label_${i18n.language}`]}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default VerticalStepper
